'use strict';

import validatorBase from './validatorBase';

var naPhone = /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/;

var regexPhone = {
	us: naPhone,
	ca: naPhone,
	jp: /^(0\d{1,4}- ?)?\d{1,4}-\d{4}$/,
	cn: /.*/,
	other: /(^[0-9]{9,18}$)|(^[00][0-9]{1,3}[0-9]{9,18}$)/,
	gb: /(^(0)(70|71|73|74|75|76|77|78|79)([0-9]{5,8})$)|(^(7624)([0-9]{3,6})$)/,	
	fr: /(^(0)([0-9]{9,9})$)/,
	es: /(^([0-9]{9,9})$)/,
	pt: /(^[0-9]{9,11}$)/,
	de: /(^(0)([0-9]{6,13})$)/,
	it: /(^[0-9]{6,11}$)/,
	nl: /(^(0)([0-9]{8,9})$)/,
	se: /(^(0)[0-9]{7,13}$)/,
	ie: /(^(0)[0-9]{7,11}$)/,
	dk: /(^[0-9]{0,8}$)/,
	be: /(^(0)([0-9]{8,9})$)/,
	gr: /(^[0-9]{10,10}$)/,
	at: /(^(0)([0-9]{4,13})$)/,
	fi: /(^(0)[0-9]{4,13}$)/,
	pl: /(^[0-9]{9,9}$)/,
	ro: /(^(0)[0-9]{9,9}$)/,
	cz: /(^[0-9]{4,12}$)/,
	hu: /(^(6|7)[0-9]{8,9}$)/,
	sk: /(^(0)[0-9]{4,9}$)/,
	mt: /(^[0-9]{8,9}$)/,
	lt: /(^(8)[0-9]{8,8}$)/,
	hr: /(^(0)[0-9]{10,10}$)/,
	lu: /(^([0-9]{4,11})$)/,
	si: /(^(0)[0-9]{7,9}$)/,
	ee: /(^[0-9]{7,10}$)/,
	cy: /(^[0-9]{8,11}$)/,
	lv: /(^[0-9]{7,8}$)/,
	bg: /(^(0)[0-9]{7,9}$)/
}

var regexPostal = {
		at:/^\d{4}$/,
    	be:/^\d{4}$/,
    	nl:/^\d{4}[ ]?[A-Z]{2}$/,
    	lu:/^\d{4}$/,
    	ie:/^[ACDEFHKNPRTVWXY]{1}[0-9]{1}[0-9W]{1}[\ \-]?[0-9ACDEFHKNPRTVWXY]{4}$/,
    	es:/^\d{5}$/,
    	bg:/^\d{4}$/,
    	cy:/^\d{4}$/,
    	cz:/^\d{3}[ ]?\d{2}$/,
    	dk:/^\d{4}$/,
		ee:/^\d{5}$/,
		hr:/^\d{5}$/,
    	fi:/^\d{5}$/,
    	gr:/^\d{3}[ ]?\d{2}$/,
    	hu:/^\d{4}$/,
    	lv:/^[Ll][Vv][ ]\d{4}$|^\d{4}$/,
    	lt:/^\d{5}$/,
    	mt:/^[A-Z]{3}[ ]?\d{2,4}$/,
    	pl:/^\d{2}[ ]\d{3}$/,
    	pt:/^\d{4}([ ]\d{3})?$/,
    	ro:/^\d{6}$/,
    	sk:/^\d{3}[ ]?\d{2}$/,
    	si:/^\d{4}$/,
    	se:/^\d{3}[ ]?\d{2}$/,
    	de:/^\d{5}$/,
    	fr:/^\d{2}[ ]?\d{3}$/,
    	it:/^\d{5}$/,
    	gb: /^(GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4})$/
    
}

var getPhoneErrorCountryMessage = function(countryCode){
    	 
	// ISO Country Code and country calling codes mapping
	var phoneErrorCountryMapping = {
		at:', zum Beispiel: 6642143512',
		be:', par exemple : 474123456',
		nl:', bijvoorbeeld: 61234567',
		lu:', for example: 621123456',
		ie:', for example: 12345678901',
		es:', por ejemplo: 611222333',
		bg:', for example: 123456789',
		cy:', for example: 12345678901',
		cz:', for example: 123456789012',
		dk:', for example: 12345678',
		ee:', for example: 1234567890',
		hr:', for example: 1234567890',
		fi:', for example: 8123456789012',
		gr:', for example: 1234567890',
		hu:', for example: 123456789',
		lv:', for example: 12345678',
		lt:', for example: 012345678',
		mt:', for example: 612345678',
		pl:', for example: 123456789',
		pt:', for example: 6234567890',
		ro:', for example: 123456789',
		sk:', for example: 112456789',
		si:', for example: 612345678',
		se:', for example: 1234567890123',
		de:', zum Beispiel: 15123456789',
		fr:', par exemple : 622334455',
		it:', ad esempio: 3342069999',
		gb:', for example: 7911123456'
	};
		
	//  return  Resources.INVALID_PHONE + phoneErrorCountryMapping[countryCode.toLowerCase()];
	 return  Resources.INVALID_PHONE;
 }

 var getPostalErrorCountryMessage = function(countryCode){
    	 
	// ISO Country Code and country calling codes mapping
	var postalErrorCountryMapping = {
		at:'Beispiel: 1010',
		be:'Exemple : 1000',
		nl:'Voorbeeld: 1011 AC',
		lu:'Example: 1111',
		ie:'Example: D02 AF30',
		es:'Ejemplo: 28001',
		bg:'Example: 1000',
		cy:'Example: 2561',
		cz:'Example: 100 00',
		dk:'Example: 1050',
		ee:'Example: 10111',
		hr:'Example: 10090',
		fi:'Example: 10100',
		gr:'Example: 104 31',
		hu:'Example: 1007',
		lv:'Example: LV–1073',
		lt:'Example: 99134',
		mt:'Example: VLT 1100 or VLT 110',
		pl:'Example: 00-001',
		pt:'Example: 1000-007',
		ro:'Example: 010164',
		sk:'Example: 241 20',
		si:'Example: 1000',
		se:'Example: 111 21',
		de:'Beispiel: 10115',
		fr:'Exemple : 75008',
		it:'Esempio: 10000',
		gb:'Example: WC2N 6HT'
	};
		
	 return  Resources.INVALID_ZIP + ' ' + postalErrorCountryMapping[countryCode.toLowerCase()];
 }

validatorBase.regex.phone = regexPhone;
validatorBase.regex.name = /^[A-ZÀÁÂÃÄÅĀĂĄǍȀȂȦǠẠḀǺḂḄḆĆČÇḈĈĊĎḐḒḊḌḎÐÉĔĚȨḜÊẾỆỀỂỄḘËĖẸȄÈẺȆĒḖḔĘẼḚḞḟǴĞǦĢĜĠḠḪȞḨĤḦḢḤÍĬǏÎÏḮİỊȈÌỈȊĪĮĨĴǰĵḰǨĶḲḴĹĽĻḼḶḸḺŁḾṀṂŃŇŅṊṄṆǸÑÓŎǑÔỐỘỒỔỖÖȪȮȰỌŐȌÒỎƠỚỢỜỞỠȎŌṒṐǪǬÕṌṎȬǾŒṔṖŔŘŖṘṚṜȐȒṞŚṤŠṦŞŜȘṠṢŤŢṰȚṪṬṮÚŬǓÛṶÜǗǙǛǕṲỤŰȔÙỦƯỨỰỪỬỮȖŪṺŲŮŨṸṴẂŴẄẆẈẀẌẊÝŶŸẎỴỲỶȲỸŹŽẐŻẒẔǮa-zàáâãäåāăąǎȀȂȦǠạḀǻḁḃḅḇćčçḉĉċďḑḓḋḍḏðéĕěȩḝêếệềểễḙëėẹȅèẻȇēḗḕęẽḛḟǵğǧģĝġḡḫȟḩĥḧḣḥẖíĭǐîïḯịȉìỉȋīįĩḭĵḱǩķḳḵĺľļḽḷḹḻłḿṁṃńňņṋṅṇǹñóŏǒôốộồổỗöȫȯȱọőȍòỏơớợờởỡȏōṓṑǫǭõṍṏȭǿœṕṗŕřŗṙṛṝȑȓṟśṥšṧşŝșṡṣßťţṱțẗṫṭṯúŭǔûṷüǘǚǜǖṳụűȕùủưứựừửữȗūṻųůũṹṵṿṽẃŵẅẇẉẁẍẋýŷÿẏỵỳỷȳẙỹźžẑżẓẕǯ’'\s\-]+$/;
validatorBase.regex.simpletext= /^[^\r\n\t\f!#\$%&\+<=>\?@\[\\\]\^_`\{\|\}~˘¤§¨°˛´ˇ¸˝×÷]*$/;
validatorBase.regex.postal = regexPostal;

validatorBase.settings.errorPlacement = function(error, element) {
	$(element).parents('.form-row').find('.error-placement').remove();
	if(element.is('select')) {
		$("<div class='error-placement'><i class='error-icon'></i><span class='error'>"+$(error).html()+"</span></div>").insertAfter($(element).parents('.field-wrapper'));
	} else {
		if($(element).hasClass("termsandconditions")) {
			if($(".order-summary-footer").next(".error-placement").length) {
				$(".order-summary-footer").next(".error-placement").remove();
			}
			if ($(element).parents(".order-summary-footer").length > 0) {
				$("<div class='error-placement consent-check-error'><span class='error'>"+$(error).html()+"</span></div>").insertAfter($(element).parents(".order-summary-footer"));
			} else {
				$("<div class='error-placement'><i class='error-icon'></i><span class='error'>"+$(error).html()+"</span></div>").insertAfter($(element).parent());
			}
		} else {
			$("<div class='error-placement'><i class='error-icon'></i><span class='error'>"+$(error).html()+"</span></div>").insertAfter($(element).parent());
		}
	}
	if(!$(element).val()  && !$(element).hasClass('this-is-invalid')) {
		$(element).closest('.form-row').find('.error-placement').addClass('make-invisible');
	}	

	setTimeout(() => {
		if(!$(element).closest('form').hasClass('submitted-error') && !$(element).val()  && !$(element).hasClass('this-is-invalid')) {
			$(element).closest('.form-row').find('.error-placement').addClass('make-invisible');
		}	
	}, 10);
}

/**
 * changeFieldValidation
 *
 * This function adds an event listener to all input elements.
 * When an input element is changed to an empty string, it adds the class 'this-is-invalid'.
 * When an input element is changed from an empty string, it removes the class 'this-is-invalid'.
 */
var changeFieldValidation  = function() {
	var inputfield = 'input'
	$(inputfield).length && $(inputfield).each(function(){
		var previousValue = $(this).val();
		if (previousValue !== '') {
			$(inputfield).on('input', function() {
				var currentValue = $(this).val();
				if (currentValue === '') {
					$(this).addClass('this-is-invalid');
				} else {
					$(this).removeClass('this-is-invalid');
				}
			});
		}
	});
}

$(window).on('load', function() {
	changeFieldValidation();
});

validatorBase.settings.onfocusout = function(element) {	
		setTimeout(() => {
			if(!$(element).val() && !$(element).hasClass('this-is-invalid') && !$(element).closest('form').hasClass('submitted-error')) {
				$(element).removeClass('error');
				$(element).closest('.form-row').find('.error-placement').remove();
			} else if ($(element).closest('form').hasClass('submitted-error')) {
				$('.error-placement').removeClass('make-invisible');
			} else {
				$(element).closest('.form-row').find('.error-placement').removeClass('make-invisible');
			}
		}, 50);

	var currentForm = element.closest('form'),
	$country = $(currentForm).find('.country option:selected').val();	
	if($country == undefined || $country.length == 0){
		$country = $(currentForm).find('input[name$="_country"]').val();
	}
	
	if($( "body" ).hasClass( "checkout_page" ) && (typeof gtCurPage !== 'undefined' && gtCurPage == 'coshipping-start' )){	
		if($(element).parents('.select-billing-address').length > 0){
			$country = $(element).parents('.select-billing-address').find('.country option:selected');
			$country = $country.length > 0 ? $country.val() : undefined;
		}
	}	
	
	if($country != undefined) {
		$country = $country.toLowerCase();
		if ($country == "gb") {
			if(element.id == $('input[id$="_postal"]').attr('id')){
				var postalVal = element.value;
				element.value = postalVal.toUpperCase();
				var validInput = postalVal.slice(-4);
				if(validInput.slice(0,1) != ' '){
					var endChar = postalVal.slice(-3);
					var startChar = postalVal.slice(0,-3);
					var result = startChar+' '+endChar;
					result = result.toUpperCase();
					element.value = $.trim(result);
				}
			}
		}
	}

	if (!this.checkable(element)) {			
		if($( "body" ).hasClass( "checkout_page" ) && (typeof gtCurPage !== 'undefined' && gtCurPage == 'coshipping-start' )){	
			if($(element).hasClass( "phonenumber" ) || $(element).hasClass( "postal" )){
				validatePostalPhone($country);
			}
		}
	    this.element(element);
	} 
}
validatorBase.settings.ignore = ":hidden:not('.hiddenRecaptcha'), .ignore, .adyen-checkout__card__holderName__input";
validatorBase.settings.errorClass = 'error';
validatorBase.settings.errorElement = 'span';

/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
var validatePhone = function (value, el) {
	var country = $(el).closest('form').find('.country option:selected').val();
	
	if($( "body" ).hasClass( "checkout_page" ) && (typeof gtCurPage !== 'undefined' && gtCurPage == 'coshipping-start' )){	
		
		 if($(el).parents('.select-billing-address').length > 0){
			 country = $(el).parents('.select-billing-address').find('.country option:selected');
			 country = country.length > 0 ? country.val() : undefined;
		}		
	}
	
	// Added to handle scenario having no country dropdown
	if(country == undefined || country.length == 0){
		country = $(el).closest('form').find('input[name$="_country"]').val();
	}

	if (country == undefined || country.length === 0 || !validatorBase.regex.phone[country.toLowerCase()]) {
		var country = 'other';
	}

	var rgx = validatorBase.regex.phone[country.toLowerCase()];
	var isOptional = this.optional(el);
	var isValid = rgx.test($.trim(value));

	// format the phone number
	$(el).val(value.replace(/\s/g,''));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}

	return isOptional || isValid;
};

var validatePostal = function (value, el) {
	
	var $form = $(el).closest('form');
	var $country = $form.find('select[name$="_country"]');
	// Added to handle scenario having no country dropdown
	if($country.length == 0){
		$country = $form.find('input[name$="_country"]');
	}
	var selectedCountry = $country.length > 0 ? $country.val() : 'us';
	
	if($( "body" ).hasClass( "checkout_page" ) && (typeof gtCurPage !== 'undefined' && gtCurPage == 'coshipping-start' )){	
				
		 if($(el).parents('.select-billing-address').length > 0){
			$country = $(el).parents('.select-billing-address').find('.country option:selected');
			selectedCountry = $country.length > 0 ? $country.val() : 'us';
		}		
	}
	
	var rgx = null;
	var isValid = false;
	if($(el).hasClass('global-zip')){
		// if universal, it accepts both US and CN values
		isValid = validatorBase.regex.postal['us'].test($.trim(value)) || validatorBase.regex.postal['cn'].test($.trim(value));
	} else {
		if(selectedCountry.toLowerCase() != ''){
			rgx = validatorBase.regex.postal[selectedCountry.toLowerCase()];
			isValid = rgx.test($.trim(value));
		}else{
			isValid = true;
		}
	}
	//Replace all non Alpha Numeric characters in postal code with a space
	$(el).val(value.replace(/[^a-z0-9]/gmi, " ").replace(/\s+/g, " "));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
};

var validateInquiry = function() {
	var inquiryLabel = $('.js-inquiry .form-row .field-wrapper');
	if($('.js-inquiry select option:selected').val() == ''){
		 $('.js-inquiry .error-placement').length && $('.js-inquiry .error-placement').remove();
		 $('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">'+ Resources.INQUIRY_ERROR +'</span></div>').insertAfter(inquiryLabel);
		 $('.js-inquiry span.ui-selectmenu-button').addClass('dropdownerror');
		 $(".contact-us-page .primary--l").prop('disabled', true);
		 inquiryLabel.addClass('this-is-invalid');
	} else {
		 $('.js-inquiry .error-placement').remove();
		 $('.js-inquiry span.ui-selectmenu-button').removeClass('dropdownerror');
	}
}

var validateDocId = function() {
	var docidLabel = $('.nationalId-list .nationalIDType.form-row label');
	if(typeof $('.nationalId-list select option:selected').val()!=='undefined'){
		if( $('.nationalId-list select option:selected').val() == ''){
			docidLabel.next('.error-placement').remove();
			$('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">'+  Resources.INVALID_NATIONAL_ID +'</span></div>').insertAfter(docidLabel);
			$('.nationalId-list span.ui-selectmenu-button').addClass('dropdownerror');
			$('form[id$="_singleshipping_shippingAddress"] [type="submit"]').attr('disabled',true);
		} else {
			$('.nationalIDType .error-placement').remove();
			$('.nationalId-list span.ui-selectmenu-button').removeClass('dropdownerror');
			$('form[id$="_singleshipping_shippingAddress"] [type="submit"]').attr('disabled',false);
		}
	}
}

var validateAddress = function (value, el) {
	var isValid = validatorBase.regex.simpletext.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
};

var showPhoneErrorCountryMessage = function(countryCode) {
	if(countryCode){		
		var callingCountryCode = getPhoneErrorCountryMessage(countryCode);
		return callingCountryCode;		
	}
};

var showPostalErrorCountryMessage = function(countryCode) {
	if(countryCode){		
		var callingCountryCode = getPostalErrorCountryMessage(countryCode);
		return callingCountryCode;		
	}
};

var validatePostalPhone = function (eleVal) {
	$.validator.addMethod('phonenumber', validatePhone, Resources.INVALID_FIELD);
	$.validator.addMethod('postal', validatePostal, Resources.INVALID_FIELD);
};

const countryChangeError = () => {
    const handleCountryChange = function() {
        validatePostalPhone($(this).val());
    };

    $('body').on('selectmenuchange change', 'select[id$="_country"]', handleCountryChange);
    validatePostalPhone();
};

var validateContactusPhone = function (value, el) {
	var regex = /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/;
	var isValid = regex.test($.trim(value));

	// format the phone number
	$(el).val(value.replace(/^(\d{3})[\s-]*(\d{3})[\s-]*(\d+)$/, "($1) $2-$3"));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
}

var replaceFirstChar = function (value) {
	var valueAfterReplace;
	var isValidFirstChar = true;
	var firstChar = value.charAt(0);
	switch(firstChar){
		case 'X':
			valueAfterReplace = value.replace(firstChar,0);
			break;
		case 'Y':
			valueAfterReplace = value.replace(firstChar,1);
			break;
		case 'Z':
			valueAfterReplace = value.replace(firstChar,2);
			break;
		default:
			valueAfterReplace = value;
			isValidFirstChar = false;
	}
	return [valueAfterReplace,isValidFirstChar];
}

var validateFiscalCode = function (value, el) {
	var nationalId = $(el).closest('form').find('.input-select.nationalidtype option:selected');
	var nationalIdSelected = nationalId.val();
	var nationalIdRegex = nationalId.data('nationalidregex');
	nationalIdRegex = new RegExp(nationalIdRegex);
	var nifExcludedRegEx = /^[0|9|1]{8}[T|R]$/;
	var isValid = nationalIdRegex.test($.trim(value));
	var letter = "TRWAGMYFPDXBNJZSQVHLCKE";

	if(isValid == true){
		var lastDigitInValue = value.charAt(value.length-1);
		if(nationalIdSelected === Constants.IDENTITY_DOC_NIF){
			var digitsInValue = value.substring(0,value.length-1);
			if(nifExcludedRegEx.test(value)){
				isValid = false;
			}else if(letter[digitsInValue % 23] === lastDigitInValue){
				isValid = true;
			}else{
				isValid = false;
			}
		}
		if(nationalIdSelected === Constants.IDENTITY_DOC_NIE){
			var replacedValue = replaceFirstChar(value);
			var valueAfterReplace = replacedValue[0];
			var isValidFirstChar = replacedValue[1];
			var digitsInValue = valueAfterReplace.substring(0,value.length-1);
			if(value === "X0000000T"){
				isValid = false;
			}else if(isValidFirstChar && (letter[digitsInValue % 23] === lastDigitInValue)){
				isValid = true;
			}else{
				isValid = false;
			}
		}
	}
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
    return isValid;
}

var validateCustomFiscalCode = function (value, el) {
	var nationalId = $(el),
		nationalIdSelected = nationalId.val(),
		nationalIdRegex = nationalId.data('nationalidregex'),
		nationalIdRegSplit = nationalIdRegex.split(/~/),
		nationalIdType = nationalId.data('nationaltype'),
		nationalIdList = nationalIdType.split(/,/),
		nifExcludedRegEx = /^[0|9|1]{8}[T|R]$/,
		lastRegValidate = new RegExp(nationalIdRegSplit[nationalIdRegSplit.length - 1]),
		isValid = lastRegValidate.test($.trim(nationalIdSelected)),
		letter = "TRWAGMYFPDXBNJZSQVHLCKE";

	$.each(nationalIdRegSplit, function (index, val) {
		var newNationalId = new RegExp(val);
		if (newNationalId.test(nationalIdSelected) === true) {
			var lastDigitInValue = value.charAt(value.length - 1);

			if (nationalIdList[index] === Constants.IDENTITY_DOC_NIF) {
				var digitsInValue = value.substring(0, value.length - 1);
				if (nifExcludedRegEx.test(value)) {
					isValid = false;
				} else if (letter[digitsInValue % 23] === lastDigitInValue) {
					isValid = true;
				} else {
					isValid = false;
				}
			}

			if (nationalIdList[index] === Constants.IDENTITY_DOC_NIE) {
				var replacedValue = replaceFirstChar(value);
				var valueAfterReplace = replacedValue[0];
				var isValidFirstChar = replacedValue[1];
				var digitsInValue = valueAfterReplace.substring(0, value.length - 1);
				if (value === "X0000000T") {
					isValid = false;
				} else if (isValidFirstChar && (letter[digitsInValue % 23] === lastDigitInValue)) {
					isValid = true;
				} else {
					isValid = false;
				}
			}
		}
	});

	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}

	return isValid;
}

var maxLengthMessage = function(value, el) {
	var message = $(el).attr('data-required-text');
	return message || $.validator.format(Resources.VALIDATE_MAXLENGTH, value)
};

var validateName = function (value, el) {
	var isValid = validatorBase.regex.name.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	return isValid;
};
var validateLastName2 = function (value, el) {
	var isValid = validatorBase.regex.name.test($.trim(value));
	if(!isValid) {
		$(el).addClass('this-is-invalid');
	}
	if (typeof value === 'string' && value === '') {
		return true; // return true if empty string provided
	} else {
		return isValid;
	}	
};

var postalcodeUppercase = function () {
	
	$('input[id$="_postal"]').on('keyup', function(){
		var countryCode = $('select[id$="_country"]').val();
		var currentObject = $(this);
		var val = $(currentObject).val().toUpperCase();
		var $length = val.length,
		$form = $(currentObject).closest('form'),
		$country = $form.find('.country option:selected').val();
		
		if($( "body" ).hasClass( "checkout_page" ) && (typeof gtCurPage !== 'undefined' && gtCurPage == 'coshipping-start' )){	
			
			 if($(this).parents('.select-billing-address').length > 0){
				$country = $(this).parents('.select-billing-address').find('.country option:selected');
				countryCode = $country.length > 0 ? $country.val() : countryCode;
				$country = countryCode;
			}		
		}
		
		if(countryCode == 'NL') {
			var postalVal = $(this).val().split(" ").join("");
			if (postalVal.length > 0) {
				postalVal = postalVal.match(new RegExp('.{1,4}', 'g')).join(" ");
			}
			$(this).val(postalVal.toUpperCase());
		}

		if($country == undefined || $country.length == 0){
			$country = $form.find('input[name$="_country"]').val();
		}
		$country = $country.toLowerCase();
		if ($country != "gb" && countryCode != 'NL'){
			$(this).val(val);
		}
	});
};

$.validator.addMethod('address1', validateAddress, Resources.INVALID_FIELD);
$.validator.addMethod('address2', validateAddress, Resources.INVALID_FIELD);
$.validator.addMethod('contactusphone', validateContactusPhone, Resources.INVALID_FIELD);
$.validator.addMethod('lastname2', validateLastName2, Resources.INVALID_FIELD);

if (!$(".pt_checkout").length) {
	$.validator.addMethod('nationalidnumber', validateFiscalCode, Resources.INVALID_FIELD);
}

if ($(".pt_checkout").length || $("#applepay-container").length) {
	$.validator.addMethod('nationalidnumber', validateCustomFiscalCode, Resources.INVALID_FIELD);
}

//$.validator.addMethod('hiddenRecaptcha', validateReCaptcha, Resources.VALIDATE_CAPTCHA);
	
$.extend($.validator.messages, {	
	maxlength: maxLengthMessage	
});

var validator = {
	regex: validatorBase.regex,
	settings: validatorBase.settings,
	init: function () {
		validatorBase.init();
		validatePostalPhone();
	},
	initForm: validatorBase.initForm,
	initStateValidation: validatorBase.initStateValidation,
	initInquiryValidation: validateInquiry,
	changeFieldValidation: changeFieldValidation,
	initDocIdValidation: validateDocId,
	initCountryChangeValidation: function() {
		countryChangeError();
		postalcodeUppercase();
	},
	initNationalIdnumber: function() {
		if ($(".pt_checkout").length || $("#applepay-container").length) {
			$.validator.addMethod('nationalidnumber', validateCustomFiscalCode, Resources.INVALID_FIELD);
		}
	}
};

export default validator;